import React from 'react';
import ReactECharts from 'echarts-for-react';

export default function LineChart({data, title, color='#0047FF', labels}) {
  const option = {
    tooltip: {
      trigger: 'axis'
    },
    grid: {
      left: '3%',
      right: '4%',
      bottom: '3%',
      containLabel: true,
      top: 10
    },
    xAxis: {
      type: 'category',
      boundaryGap: false,
      data: labels || ['Mon','Tue','Wed','Thu','Fri','Sat','Sun'],
      axisLine: { show: false },
      axisTick: { show: false },
      axisLabel: { color: '#9CA3AF' }
    },
    yAxis: {
      type: 'value',
      splitLine: {
        lineStyle: { type: 'dashed', color: '#F3F4F6' }
      },
      axisLabel: { show: false }
    },
    series: [
      {
        name: title,
        type: 'line',
        smooth: true,
        data: data || [0,0,0,0,0,0,0],
        itemStyle: { color: color },
        areaStyle: {
          color: {
            type: 'linear',
            x: 0, y: 0, x2: 0, y2: 1,
            colorStops: [
              { offset: 0, color: `${color}40` },
              { offset: 1, color: `${color}00` }
            ]
          }
        },
        symbol: 'circle',
        symbolSize: 8,
        lineStyle: { width: 3 }
      }
    ]
  };

  return <ReactECharts option={option} style={{height: '300px', width: '100%'}} />;
}